// extracted by mini-css-extract-plugin
var _1 = "_oYfAn5Z";
export { _1 as "tags" }
